import {Section} from "../../grouping/Section";
import {Col, FormControl} from "react-bootstrap";
import {ListItemButton} from "../../ListItemButton";
import {IoAddCircle} from "react-icons/io5";
import {useState} from "react";
import {IoIosRemoveCircle} from "react-icons/io";

export function SelectList(props) {
    const {list, onItemSelectedChanged, itemSelected} = props

    const albumsCopy = list ? [...list] : []
    const albumsOrdered = albumsCopy?.sort((a1, a2) => new Date(a2.dateCreated).getTime() - new Date(a1.dateCreated).getTime())
    return <Section>
        {albumsOrdered ? albumsOrdered.map(l => <AlbumSelectListItem key={l.id}
                                                                     itemSelected={itemSelected}
                                                                     onItemSelectedChanged={onItemSelectedChanged}
                                                                     item={l}/>) : "Nog geen items aangemaakt!"}
    </Section>
}


function AlbumSelectListItem(props) {
    const {item, itemSelected, onItemSelectedChanged} = props;
    const [added, setAdded] = useState(itemSelected.filter(a => a.id === item.id).length > 0)
    return <Section>
        <Col>{item?.title}</Col>
        <Col>{item?.dateCreated?.substring(0, 10)}</Col>
        <Col xs={"auto"}><ListItemButton onClick={() => {
            onItemSelectedChanged(!added ? [...itemSelected, item] : itemSelected.length > 0 ? itemSelected.filter(a => a.id !== item.id) : itemSelected)
            setAdded(!added);
        }}>{added ? <IoIosRemoveCircle size={25}/> : <IoAddCircle size={25}/>}</ListItemButton> </Col>

    </Section>
}